import { useTranslation } from 'react-i18next';
import { FaqList } from '@/features/faq/FaqList';

export function FaqPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-5">
      <header>
        <h1 className="headline text-[22px] uppercase tracking-[0.02em]">
          {t('faq.title')}
        </h1>
        <div className="hairline mt-2 w-12" />
      </header>
      <FaqList />
    </div>
  );
}
